import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  float?: boolean;
};
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className,
  float = false
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-500" data-mp="3bjyucwrp1ie0">
      {float ? <motion.div animate={{
      y: [0, -6, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut",
      delay: delay + 0.6 // Start floating after reveal
    }} className="h-full w-full" data-id="element-501" data-mp="2nsjx3ierxr9m">
          {children}
        </motion.div> : children}
    </motion.div>;
}